import axios from 'axios'

import {getCSRFToken} from 'js/utils/csrf_token'

interface SubscriptionStatusJSON {
  status: 'pending' | 'subscribed' | 'unsubscribed'
}

export const privateAPI = (path: string): string => `/api/v2private/${path}`

export const getMarketplaceStatus = async (
  statusRoute: string
): Promise<SubscriptionStatusJSON> =>
  (await axios.get(statusRoute)).data as SubscriptionStatusJSON

export const createAccount = (): Promise<void> => {
  return axios.post(privateAPI('accounts'), {
    _csrf_token: getCSRFToken(),
  })
}

export const authConnection = async (email: string): Promise<string> => {
  const response = await axios.get(privateAPI('auth/connection'), {
    params: {email},
  })

  return response.data
}

export type AuthConnection = typeof authConnection
